
















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import dayjs from "dayjs";
import Project from "@/lib/Project";
import TaskEditor from "@/components/TaskEditor.vue";
import Utils from "@/lib/Utils";
import { openDialog } from "@/lib/openDialog";
import TargetTask from "@/lib/TargetTask";
import { colorList } from "@/constants/colorList";

@Component({
	components: { TaskEditor }
})
export default class TaskItem extends Vue {

	@Prop({ type: String, required: true })
	taskId!: string;

	@Prop({ type: Boolean, default: true })
	showProjectName!: boolean;

	isEditing = false;

	popoverVisible = false;

	get task(): TargetTask {
		return (this.$store.state.targetTaskList as TargetTask[]).find(i => i.id === this.taskId) || new TargetTask();
	}

	beforeCreate(): void {
		this.$store.commit("fetchTaskList");
		// this.$store.commit("fetchProjectList");
	}

	get isOverdue(): boolean {
		console.log(this.task)
		if (this.task.dueDate !== null) {
			if (dayjs(this.task.dueDate).isBefore(dayjs(new Date()), 'day') && this.task.status === 1) {
				console.log("逾期1")
				return true;
			}
		} else if (this.task.status == 3) {
			console.log("逾期2")
			return true;
		}
		console.log("正常3")
		return false;
	}
	get taskProjectName(): string {
		// if(this.task.project_id === "-1") {
		//     return "收集箱";
		// }
		const projectList = this.$store.state.projectList as Project[];
		const project = projectList.find(i => i.id === this.task.targetId);
		if (project !== undefined) {
			return project.name;
		} else {
			// return "收集箱";
			return "";
		}
	}

	get color(): string {
		if (this.task.targetId === '' || this.task.targetId === undefined) return "";
		const projectList = this.$store.state.projectList as Project[];
		const project = projectList.find(i => i.id === this.task.targetId);
		if (project) {
			return project.color;
		}
		return colorList[0].base;
	}

	get taskDueDate(): string {
		if (this.task.dueDate === undefined) {
			return "";
		}
		return Utils.formatDate(new Date(this.task.dueDate || new Date()));
	}

	deleteTask(id: string): void {
		this.$store.commit("deleteTask", id);
		this.$message({
			message: '删除成功',
			type: 'info',
			showClose: true,
		});
	}


	finishTask(id: string): void {
		if (this.task.status === 2) {
			this.$message({
				message: '任务已完成了，无需重复完成！',
				type: 'error',
				showClose: true,
			});
			return;
		}
		this.openFinishTaskDialog(id);
		// this.$store.commit("finishTask",id);
		// this.$message({
		//      message: '任务已完成',
		//      type: 'success',
		//      showClose: true,
		// });
	}

	openFinishTaskDialog(id: string): void {
		openDialog(id, "FinishTaskDialog");
	}


}
